import { AgeRange } from "shared/types";
import {
  LIST_AGE_RANGES,
  type AgeRangeDispatchAction,
} from "../actions/ageRangeActions";

export type AgeRangeState = {
  ageRanges: AgeRange[];
};

export const initialState: AgeRangeState = {
  ageRanges: [],
};

export default function ageRangeReducer(
  state: AgeRangeState = initialState,
  action: AgeRangeDispatchAction
): AgeRangeState {
  if (action.type === LIST_AGE_RANGES) {
    return {
      ...state,
      ageRanges: action.payload.ageRanges,
    };
  }

  return { ...state };
}
